<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<app-loading-overlay></app-loading-overlay>
<router-outlet></router-outlet>
